import { Anlage } from "./anlage"
import { FilePickerError } from "./fileInfo"

export class UploadAnlage extends Anlage {
    datei?: File
    dateiError?: FilePickerError
    multipartIndex?: number

    get notEmpty(): boolean {
        return !!this.datei
    }

    getMimeType(name: string, fallback: string) {
        const mimeTypes = new Map<string, string>()
        mimeTypes.set("pdf", "application/pdf")
        mimeTypes.set("png", "image/png")
        mimeTypes.set("jpg", "image/jpeg")
        mimeTypes.set("jpeg", "image/jpeg")
        mimeTypes.set("csv", "text/csv")
        mimeTypes.set("xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
        mimeTypes.set("ods", "application/vnd.oasis.opendocument.spreadsheet")
        const extension = name.substr(name.lastIndexOf(".") + 1)

        return mimeTypes.has(extension) ? mimeTypes.get(extension) : fallback
    }

    toJSON() {
        return this.notEmpty
            ? {
                  "@type": "uploadAnlage",
                  name: this.name,
                  beschreibung: this.beschreibung,
                  dateiname: this.datei?.name,
                  mimeType: this.getMimeType((this.datei as Required<File>).name, (this.datei as Required<File>).type),
                  multipartIndex: this.multipartIndex,
              }
            : {
                  "@type": "uploadAnlage",
              }
    }
}
